import { Routes } from '@angular/router';

import { WebsiteLayoutsComponent } from './website/layouts/website-layouts/website-layouts.component';
import { AuthLayoutComponent } from './portal/layouts/auth-layout/auth-layout.component';
import { AuthorizedGuard } from './portal/guards/authorized/authorized.guard';
import { StandardLayoutComponent } from './portal/layouts/standard-layout/standard-layout.component';
import { UnauthorizedGuard } from './portal/guards/unauthorized/unauthorized.guard';
// import { StepguardGuard } from './portal/guards/stepguard/stepguard.guard';
import { StepAuthGuardGuard } from './portal/guards/stepAuthGuard/step-auth-guard.guard';
import { WebsiteCMSlayoutComponent } from './websiteCMS/website-cmslayout/website-cmslayout.component';
import { CompanyDetailsAccessGuard } from './portal/guards/company-details/company-details.guard';
import { CategoryGuard } from './portal/guards/category/category.guard';
import { AllformSubmitted } from './portal/guards/allform-submitted/allform-submitted.guard';

export const routes: Routes = [
  {
    path: '',
    component: WebsiteLayoutsComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./website/pages/home/home.module').then((h) => h.HomeModule),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('./website/pages/contact/contact.module').then(
            (c) => c.ContactModule,
          ),
      },
      {
        path: 'key-statistics/:tab',
        loadChildren: () =>
          import('./website/pages/keystat/keystat.module').then(
            (k) => k.keystatModule,
          ),
      },
      {
        path: 'incentive-guidelines',
        loadComponent: () =>
          import(
            './website/pages/incentive-guidelines/incentive-guidelines.component'
          ).then((m) => m.IncentiveGuidelinesComponent),
      },
      {
        path: 'incentive-scheme-page',
        loadComponent: () =>
          import(
            './website/pages/incentive-scheme/incentive-scheme.component'
          ).then((m) => m.IncentiveSchemeComponent),
      },
      {
        path: 'incentive-scheme-notifications',
        loadComponent: () =>
          import(
            './website/pages/incentive-notification/incentive-notification.component'
          ).then((m) => m.IncentiveNotificationComponent),
      },
      {
        path: 'incentive-faqs',
        loadComponent: () =>
          import('./website/pages/incentive-faq/incentive-faq.component').then(
            (m) => m.IncentiveFaqComponent,
          ),
      },
      {
        path: 'registration-benefits',
        loadComponent: () =>
          import(
            './website/pages/registration-benefits/registration-benefits.component'
          ).then((m) => m.RegistrationBenefitsComponent),
      },
      {
        path: 'site-map',
        loadComponent: () =>
          import('./website/pages/site-map/site-map.component').then(
            (m) => m.SiteMapComponent,
          ),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./website/pages/about/about.module').then(
            (a) => a.AboutModule,
          ),
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./website/pages/events/events.module').then(
            (a) => a.EventsModule,
          ),
      },
      {
        path: 'secretary-message',
        loadChildren: () =>
          import('./website/pages/directormsg/directormsg.module').then(
            (d) => d.Directormsg,
          ),
      },
      {
        path: 'vision-mission',
        loadChildren: () =>
          import('./website/pages/visionmission/directormsg.module').then(
            (v) => v.VisionMission,
          ),
      },
      {
        path: 'whoswho',
        loadChildren: () =>
          import('./website/pages/whoswho/whos.module').then((w) => w.WhosWho),
      },
      {
        path: 'policy',
        loadChildren: () =>
          import('./website/pages/policy/policy.module').then(
            (p) => p.policyModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () =>
          import('./website/pages/terms/terms.module').then(
            (t) => t.termsModule,
          ),
      },

      {
        path: 'copyright',
        loadChildren: () =>
          import('./website/pages/copyright/copyright.module').then(
            (co) => co.copyrightModule,
          ),
      },
      {
        path: 'hyperlinking',
        loadChildren: () =>
          import('./website/pages/hyperlinking/hyperlinking.module').then(
            (h) => h.hyperlinkingModule,
          ),
      },
      {
        path: 'accessibility',
        loadChildren: () =>
          import('./website/pages/accessibility/accessibility.module').then(
            (ac) => ac.accessibilityModule,
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./website/pages/faq/faq.module').then((f) => f.faqModule),
      },
      {
        path: 'feedback',
        loadChildren: () =>
          import('./website/pages/feedback/feedback.module').then(
            (fe) => fe.feedbackModule,
          ),
      },
      {
        path: 'Stakeholdernfmwebinar',
        loadComponent: () =>
          import(
            './website/pages/stakeholdernfmwebinar/stakeholdernfmwebinar.component'
          ).then((m) => m.StakeholdernfmwebinarComponent),
      },
      {
        path: 'enquiry',
        loadChildren: () =>
          import('./website/pages/contact/contact.module').then(
            (m) => m.ContactModule,
          ),
      },
    ],
  },
  {
    path: '',
    component: StandardLayoutComponent,
    canActivate: [AuthorizedGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./portal/pages/dashboard/dashboard.module').then(
            (d) => d.DashboardModule,
          ),
      },
      {
        path: 'green-rating',
        loadChildren: () =>
          import('./portal/pages/green-rating/green-rating.module').then(
            (gr) => gr.GreenRatingModule,
          ),
      },
      {
        path: 'industry-rating',
        loadChildren: () =>
          import('./portal/pages/industry-rating/industry-rating.module').then(
            (gr) => gr.IndustryRatingModule,
          ),
      },
      {
        path: 'stakeholder-directory',
        loadChildren: () =>
          import(
            './portal/pages/stakeholder-directory/stakeholder-directory.module'
          ).then((gr) => gr.StakeholderDirectoryModule),
      },
      {
        path: 'manage-requests',
        loadChildren: () =>
          import(
            './portal/pages/manage-requests-all/manage-requests-all.module'
          ).then((m) => m.ManageRequestsAllModule),
      },
      {
        path: 'incentive-scheme',
        loadChildren: () =>
          import(
            './portal/pages/incentive-scheme/incentive-scheme.module'
          ).then((m) => m.IncentiveSchemeModule),
      },
      {
        path: 'incentive-form-log',
        loadChildren: () =>
          import(
            './portal/pages/incentive-form-log/incentive-form-log.module'
          ).then((m) => m.IncentiveFormLogModule),
      },
      {
        path: 'appointment-requests',
        loadChildren: () =>
          import(
            './portal/pages/appointment-requests/appointment-requests.module'
          ).then((m) => m.AppointmentRequestsModule),
      },
      {
        path: 'event-and-announcements',
        loadChildren: () =>
          import(
            './portal/pages/event-and-announcements/event-and-announcements.module'
          ).then((m) => m.EventAndAnnouncementsModule),
      },
      {
        path: 'help-support',
        loadChildren: () =>
          import('./portal/pages/help-support/help-support.module').then(
            (h) => h.HelpSupportModule,
          ),
      },
      {
        path: 'users-management',
        loadChildren: () =>
          import(
            './portal/pages/users-management/users-management.module'
          ).then((u) => u.UsersManagementModule),
      },
      {
        path: 'update-profile',
        loadChildren: () =>
          import('./portal/pages/update-profile/update-profile.module').then(
            (u) => u.UpdateProfileModule,
          ),
      },
      {
        path: 'green-rating-form',
        loadChildren: () =>
          import(
            './portal/pages/green-rating-form/green-rating-form.module'
          ).then((grf) => grf.GreenRatingFormModule),
      },
      {
        path: 'circulars',
        loadChildren: () =>
          import('./portal/pages/circulars/circulars.module').then(
            (c) => c.CircularsModule,
          ),
      },
      {
        path: 'government-policies',
        loadChildren: () =>
          import(
            './portal/pages/government-policies/government-policies.module'
          ).then((grf) => grf.GovernmentPoliciesModule),
      },
      // {
      //   path: 'government-policies',
      //   loadChildren: () =>
      //     import('./portal/pages/survey-response/survey-response.module').then(
      //       (s) => s.SurveyResponseModule,
      //     ),
      // },
      {
        path: 'submit-rd-needs',
        loadChildren: () =>
          import('./portal/pages/submit-rd-needs/submit-rd-needs.module').then(
            (s) => s.SubmitRdNeedsModule,
          ),
      },
      {
        path: 'apply-for-rating',
        loadChildren: () =>
          import(
            './portal/pages/apply-for-rating/apply-for-rating.module'
          ).then((a) => a.ApplyForRatingModule),
      },
      {
        path: 'feedbacks',
        loadChildren: () =>
          import('./portal/pages/feedback/feedback.module').then(
            (f) => f.FeedbackModule,
          ),
      },
      {
        path: 'appointment-request-form',
        loadChildren: () =>
          import(
            './portal/pages/appointment-request-form/appointment-request-form.module'
          ).then((af) => af.AppointmentRequestFormModule),
      },
      {
        path: 'industry-rating-form',
        loadChildren: () =>
          import(
            './portal/pages/industry-rating-form/industry-rating-form.module'
          ).then((grf) => grf.IndustryRatingFormModule),
      },
      {
        path: 'need-support',
        loadChildren: () =>
          import('./portal/pages/queries/queries.module').then(
            (q) => q.QueriesModule,
          ),
      },
      {
        path: 'applyforinsentive',
        loadComponent: () =>
          import(
            './portal/pages/applyfor-incentive-scheme/applyfor-incentive-scheme.component'
          ).then((q) => q.ApplyforIncentiveSchemeComponent),
      },
    ],
  },
  {
    path: '',
    component: WebsiteCMSlayoutComponent,
    canActivate: [AuthorizedGuard],
    children: [
      {
        path: 'imporatntUpdate',
        loadChildren: () =>
          import(
            './websiteCMS/pages/important-update/imporant-update.module'
          ).then((d) => d.ImporantUpdateModule),
      },
      {
        path: 'upcomingEvents',
        loadChildren: () =>
          import('./websiteCMS/pages/events/events.module').then(
            (d) => d.EventsModule,
          ),
      },
      {
        path: 'latestnews',
        loadChildren: () =>
          import('./websiteCMS/pages/latest-news/latest-news.module').then(
            (d) => d.LatestNewsModule,
          ),
      },
      {
        path: 'herosection',
        loadChildren: () =>
          import('./websiteCMS/pages/hero-section/hero-section.module').then(
            (d) => d.HeroSectionModule,
          ),
      },
      {
        path: 'whoiswho',
        loadChildren: () =>
          import('./websiteCMS/pages/whos-who/whos-who.module').then(
            (d) => d.WhosWhoModule,
          ),
      },
      {
        path: 'externallink',
        loadChildren: () =>
          import('./websiteCMS/pages/external-link/external-link.module').then(
            (d) => d.ExternalLinkModule,
          ),
      },
      {
        path: 'gallerySection',
        loadChildren: () =>
          import('./websiteCMS/pages/gallery/gallery.module').then(
            (d) => d.GalleryModule,
          ),
      },
      {
        path: 'videoSection',
        loadChildren: () =>
          import('./websiteCMS/pages/video/video.module').then(
            (d) => d.VideoModule,
          ),
      },
      {
        path: 'circular',
        loadComponent: () =>
          import('./websiteCMS/pages/circular/circular.component').then(
            (m) => m.CircularComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [UnauthorizedGuard],
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./portal/pages/auth/auth.module').then((a) => a.AuthModule),
      },
      {
        path: 'sso_auth',
        loadComponent: () =>
          import('./portal/callback/callback.component').then(
            (c) => c.CallbackComponent,
          ),
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./portal/pages/login/login.module').then(
            (l) => l.LoginModule,
          ),
      },
      {
        path: 'verify',
        canActivate: [StepAuthGuardGuard],
        loadChildren: () =>
          import('./portal/pages/verify-otp/verify-otp.module').then(
            (v) => v.VerifyOtpModule,
          ),
      },
      {
        path: 'required-details',
        // canActivate: [StepguardGuard],
        loadChildren: () =>
          import(
            './portal/pages/required-details/required-details.module'
          ).then((r) => r.RequiredDetailsModule),
      },
      {
        path: 'category',
        canActivate: [CategoryGuard],
        loadChildren: () =>
          import('./portal/pages/category/category.module').then(
            (c) => c.CategoryModule,
          ),
      },
      {
        path: 'category-main',
        canActivate: [CategoryGuard],
        loadChildren: () =>
          import('./portal/pages/main-category/main-category.module').then(
            (m) => m.MainCategoryModule,
          ),
      },
      {
        path: 'user-details',
        canActivate: [CompanyDetailsAccessGuard],
        loadChildren: () =>
          import('./portal/pages/user-details/user-details.module').then(
            (u) => u.UserDetailsModule,
          ),
      },
      {
        path: 'user-authorized-details',
        canActivate: [CompanyDetailsAccessGuard],
        loadChildren: () =>
          import(
            './portal/pages/user-authorized-details/user-authorized-details.module'
          ).then((u) => u.UserAuthorizedDetailsModule),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./portal/pages/forgot-password/forgot-password.module').then(
            (f) => f.ForgotPasswordModule,
          ),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./portal/pages/reset-password/reset-password.module').then(
            (r) => r.ResetPasswordModule,
          ),
      },
      {
        path: 'recyclers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/recycler-metal-details-form/recycler-metal-details-form.module'
          ).then((r) => r.RecyclerMetalDetailsFormModule),
      },
      {
        path: 'traders',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/traders-metal-details-form/traders-metal-details-form.module'
          ).then((r) => r.TradersMetalDetailsFormModule),
      },
      {
        path: 'aggregators',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/aggregators-metal-details-form/aggregators-metal-details-form.module'
          ).then((r) => r.AggregatorsMetalDetailsFormModule),
      },
      {
        path: 'dismantlers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/dismantlers-metal-details-form/dismantlers-metal-details-form.module'
          ).then((r) => r.DismantlersMetalDetailsFormModule),
      },
      {
        path: 'collection-centers',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/collection-centres-metal-details-form/collection-centres-metal-details-form.module'
          ).then((r) => r.CollectionCentresMetalDetailsFormModule),
      },
      {
        path: 'associations',
        canActivate: [AllformSubmitted],
        loadChildren: () =>
          import(
            './portal/pages/associations-form/associations-form.module'
          ).then((a) => a.AssociationsFormModule),
      },
    ],
  },
  {
    path: 'server-error',
    loadComponent: () =>
      import('./portal/components/error-server/error-server.component').then(
        (e) => e.ErrorServerComponent,
      ),
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./portal/pages/not-found/not-found.module').then(
        (n) => n.NotFoundModule,
      ),
  },
  {
    path: 'resubmitting',
    loadChildren: () =>
      import('./portal/pages/thankyou-page/thankyou-page.module').then(
        (n) => n.ThankyouPageModule,
      ),
  },
  {
    path: 'under-review',
    loadChildren: () =>
      import('./portal/pages/await-message/await-message.module').then(
        (a) => a.AwaitMessageModule,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'not-found',
  },
];
